<div class="container mt-5 mb-3">
    <app-subtitle-hr [title]="'Mis notificaciones'"></app-subtitle-hr>
    <div class="row mt-3">
        <div class="card">

            <div class="card-body">

                <div class="flex justify-content-center">
                    <p-paginator #paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
                      [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]" [showCurrentPageReport]="true"
                      currentPageReportTemplate="{first} - {last} de {totalRecords}"></p-paginator>
                  </div>

                <p-table #table [showCurrentPageReport]="true" [tableStyle]="{ 'min-width': '50rem' }"
                    [styleClass]="'p-datatable-sm mt-3'" [value]="forms" dataKey="id" (onSort)="onSort($event)">
                    <ng-template pTemplate="header">
                        <tr class="dark-tr">
                            <th pSortableColumn="id_visible">
                                ID <fa-icon [icon]="['fas', 'sort']"></fa-icon>
                            </th>
                            <th>Título</th>
                            <th>Descripción</th>
                            <th>Fecha</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-form>
                        <tr class="item" (click)="onRowSelect(form.link)">
                            <td>
                                <p pTooltip="{{ form.id_visible }}">{{ form.id_visible }}</p>
                            </td>
                            <td>
                                <p pTooltip="{{ form.titulo }}">
                                    {{ form.titulo }}</p>
                            </td>
                            <td>
                                <p pTooltip="{{ form.descripcion }}">
                                    {{ form.descripcion }}</p>
                            </td>
                            <td>
                                <p pTooltip="{{ form.fecha_creado | date: 'dd/MM/yyyy' }}">
                                    {{ form.fecha_creado | date: 'dd/MM/yyyy' }}</p>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <div class="flex justify-content-center">
                    <p-paginator #paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
                      [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]" [showCurrentPageReport]="true"
                      currentPageReportTemplate="{first} - {last} de {totalRecords}"></p-paginator>
                  </div>
            </div>
        </div>
    </div>
</div>

<app-back-button routerLink="../" />